const prefix = 'ADD_MORE_PRODUCTS_MODAL'

// ACTIONS
export const SET_COLLECTION_ID = `${prefix}/SET_COLLECTION_ID`
export const SET_SEARCH_TEXT = `${prefix}/SET_SEARCH_TEXT`
